import IntlMessageFormat from 'intl-messageformat';
export class TranslationKeyError extends Error {
    constructor(key){
        super("Translation key not found: ".concat(key));
        this.name = 'TranslationKeyError';
    }
}
function resolveKey(translations, key) {
    const parts = key.split('.');
    let current = translations;
    for (const part of parts){
        if (current == null || typeof current !== 'object') {
            return undefined;
        }
        current = current[part];
    }
    if (typeof current !== 'string') {
        return undefined;
    }
    return current;
}
export function createTranslationResolver(options) {
    const { primary, fallback } = options;
    return {
        t (key, values) {
            var _resolveKey;
            const template = (_resolveKey = resolveKey(primary, key)) !== null && _resolveKey !== void 0 ? _resolveKey : fallback != null ? resolveKey(fallback, key) : undefined;
            if (template == null) {
                throw new TranslationKeyError(key);
            }
            if (values == null) {
                return template;
            }
            const message = new IntlMessageFormat(template, 'en');
            return message.format(values);
        }
    };
}
